export enum Animal {
  Toucan = 1, Chameleon = 2
}

export default Animal
